
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton, InputBase } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import { useStoreState } from 'pullstate';
import { AppStore } from '../stores/AppStore.js';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: 4,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    marginRight:'16px',
    width: '100%',
    // [theme.breakpoints.up('sm')]: {
    //     marginLeft: theme.spacing(1),
    //     width: '30%'
    // }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: '12px',
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color:'#0009', 
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    // backgroundColor: alpha(theme.palette.common.black, 0.15),
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        backgroundColor: alpha(theme.palette.common.black, 0.15),
        borderRadius:4,
        // [theme.breakpoints.up('sm')]: {
        //     width: '12ch',
        //     '&:focus': {
        //         width: '20ch'
        //     }
        // }
    }
}));

const ClearIconWrapper = styled('div')(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(1),
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1
}));

const SearchField = (props) => {
    const searchText = useStoreState(AppStore, s => s.searchText);
    const { setSearchValue } = props;
    const setSearchText = (value) => {
        AppStore.update(s => { s.searchText = value });
    }

    const handleClear = () => {
        setSearchValue ? setSearchValue('') : '';
        setSearchText('');
    }

    return (
        <Search style={{ width: '20%', position: 'relative' }}>
            <SearchIconWrapper>
                <SearchIcon sx={{ fontSize: 24 }}/>
            </SearchIconWrapper>
            <StyledInputBase
                placeholder="Search…"
                inputProps={{ 'aria-label': 'search' }}
                value={searchText}
                onChange={(event) => {
                    setSearchValue ? setSearchValue(event.target.value) : ''
                    setSearchText(event.target.value)
                }}
            />
            {searchText && (
                <ClearIconWrapper>
                    <IconButton
                        size="small"
                        onClick={handleClear}
                        aria-label="clear search"
                        tabIndex={0}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </ClearIconWrapper>
            )}
        </Search>
    )
}

export default SearchField;
